// NOTE: THIS SHOULD REALLY LIVE IN RSUI
/**
 * Simple pluralization (or singularization) of a word based on the passed in count.
 *
 * @param {string} word The word to pluralize
 * @param {number} count How many of the 'word' exist
 * @param {object} options The options object
 * @param {boolean} options.inclusive Specify whether to prefix with the number (e.g. 3 ducks)
 * @return {string}
 */
const pluralize = (word, count, options) => {
  const pluralizedWord = count === 1 ? word : `${word}s`;

  if (!options?.inclusive) {
    return pluralizedWord;
  }

  return `${count} ${pluralizedWord}`;
};

export default pluralize;
